<template>
  <div v-if="image" aria-hidden="true">
    <RevLink
      v-if="!isCartLocked && link"
      class="cursor-pointer"
      tabindex="-1"
      target="_blank"
      :to="link"
    >
      <Illustration :src="image" />
    </RevLink>

    <Illustration v-else :src="image" />
  </div>
</template>

<script lang="ts" setup>
import { inject } from 'vue'

import type { LinkInternal } from '@backmarket/http-api/src/api-models/LinkInternal'
import { RevLink } from '@ds/components/Link'

import Illustration from './Illustration.vue'

const isCartLocked = inject('isCartLocked', false)

defineProps<{
  image: string
  link?: string | null | LinkInternal
}>()
</script>
